<script>
  import { push } from 'svelte-spa-router';
  import { Compass } from '../lib/icons/index.js';
  import Layout from '../components/Layout.svelte';
  import { t } from '../i18n/index.js';
</script>

<Layout>
  <div class="flex flex-col items-center text-center py-20">
    <Compass size={40} class="mb-4 text-action/70" />
    <h1 class="section-title">{$t('app.notFoundTitle')}</h1>
    <p class="text-muted text-sm max-w-md">{$t('app.notFoundBody')}</p>
    <button class="btn btn-primary mt-6" on:click={() => push('/')}>{$t('app.backHome')}</button>
  </div>
</Layout>
